// extracted by mini-css-extract-plugin
export default {"filterArrow":"FilterWindow_filterArrow__jVG0J","hideArrow":"FilterWindow_hideArrow__O0P-7","placeHolderShimmer":"FilterWindow_placeHolderShimmer__QExMG"};